<template lang="pug">
  #signUpSuccess
    .container-width.p-3
      .icon
        .icon-area
          .icon-success.mx-auto.text-center
            .mb-5
              .action.d-flex.align-items-center
                .trophy.mx-auto
                  .circle.p-1(style='border-radius: 0; border: 1px solid #000000; background-color: #FFFFFF')
                    .w-100.h-100(style='background-color: #000000')
                      img(
                        :src='okImg',
                        alt='success_ok_img'
                      )
            h4(
              v-if='!alreadyBind'
            ) 會員註冊成功!
            h2(v-else) 您已是會員
            h2(v-if='alreadyBind') 無需再註冊
      p(v-if='!alreadyBind') 恭喜您成功完成會員註冊，我們將不定期提供給您最新活動訊息。
      .fakePadding_h-50
      //.row.p-3.pt-5.mx-2
        .col-12
          button.button.btn-block.button_clickCustom.button_clickCustom-primary.button_fixedAtBottom(
            type="button",
            @click="backToLINEHandler()"
          ) 返回官方帳號
</template>

<script>
  import okImgUrl from '@/assets/images/icon/icon_ok.png';

  export default {
    name: 'memberSuccess',
    props: {
      alreadyBind: {
        type: Boolean,
        require: false,
      },
    },
    data() {
      return {
        okImg: okImgUrl
      };
    },
    mounted() {
      const vm = this;
      vm.$store.commit('toggleLoading', false);
    },
    methods: {
      backToLINEHandler() {
        window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
      }
    }
  };
</script>

<style lang="scss" scoped>
  #signUpSuccess {
    // background: url('~@/assets/images/bg/bg_success.png')no-repeat center center;
    background-size: contain;
    background-position-y: 30%;
  }

  .action {
    height: 30vh;
  }
</style>
